export enum Due {
  Today = "today",
  Later = "later",
  Archived = "archived",
}
